import React, { FC, memo } from "react";

const SettingsRow: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fill="#495A64"
      d="M9.161 13.47a4.063 4.063 0 1 1 4.063-4.063 4.063 4.063 0 0 1-4.063 4.065zm8.843-2l-1.729-1.352c.027-.236.04-.473.041-.71 0-.237-.014-.475-.04-.71l1.73-1.353a.848.848 0 0 0 .2-1.08l-1.8-3.111a.834.834 0 0 0-1.04-.374l-2.036.82a7.058 7.058 0 0 0-1.225-.71l-.31-2.168a.833.833 0 0 0-.83-.721H7.357a.832.832 0 0 0-.829.715l-.31 2.172c-.43.197-.84.435-1.224.71l-2.047-.82a.851.851 0 0 0-1.032.368L.116 6.26a.844.844 0 0 0 .2 1.086L2.05 8.7a6.242 6.242 0 0 0 0 1.42L.32 11.47a.849.849 0 0 0-.2 1.08l1.8 3.112c.201.37.648.53 1.04.374l2.04-.82a7.03 7.03 0 0 0 1.225.712l.31 2.164a.833.833 0 0 0 .831.723h3.606a.83.83 0 0 0 .83-.715l.311-2.172c.43-.197.84-.435 1.223-.712l2.046.822a.833.833 0 0 0 1.032-.367l1.806-3.128a.845.845 0 0 0-.215-1.074z"
    />
  </svg>
);

export default memo(SettingsRow);
